import { isIvdrDeployment } from 'common/environmentConfig'
import { Routes } from 'common/routeConfig'
import { useDataContext } from 'context/DataContext'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const Footer = () => {
    const { t } = useTranslation('common')
    const { metaInfo } = useDataContext()
    const calculationDate = metaInfo?.calculationDate?.trim()

    return (
        <footer className="footer">
            <div className="footer__logoContainer">
                <div className="footer__logo" />
            </div>

            <div className="footer__linkContainer">
                {isIvdrDeployment && (
                    <>
                        <Link to={Routes.IFU}>{t('footer.ifu')}</Link>
                        <Link to={Routes.LABEL}>
                            {t('footer.productLabel')}
                        </Link>
                    </>
                )}
                <Link to={Routes.DISCLAIMER}>{t('footer.disclaimer')}</Link>
            </div>

            {calculationDate && (
                <div className="footer__calculationDate">
                    {t('footer.calculationDate', { date: calculationDate })}
                </div>
            )}
        </footer>
    )
}

export default Footer
